import React, { useState } from "react";
import axios from "axios";
import { API } from "../shared/constants";
import { inputStyle, labelStyle } from "../shared/styles";
import { SimpleModal } from "../shared/SimpleModal";

export function UnitFormModal({ siteId, areaId, existingUnit, onClose, onSave }) {
  const isEdit = !!existingUnit;
  const [form, setForm] = useState({
    unit_type: existingUnit?.unit_type || "tenant",
    name: existingUnit?.name || "",
    unit_number: existingUnit?.unit_number || "",
    floor_level: existingUnit?.floor_level || "",
    notes: existingUnit?.notes || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      if (isEdit) {
        await axios.patch(`${API}/site-units/${existingUnit.id}/`, form);
      } else {
        await axios.post(`${API}/site-units/`, { ...form, site: siteId, area: areaId ?? null });
      }
      onSave();
    } catch {
      setError("Save failed. Please try again.");
    }
    setSaving(false);
  };

  const field = (label, key, type = "text", placeholder = "") => (
    <div style={{ marginBottom: "14px" }}>
      <label style={{ ...labelStyle, display: "block", marginBottom: "4px" }}>{label}</label>
      <input
        type={type}
        value={form[key]}
        onChange={(e) => setForm({ ...form, [key]: e.target.value })}
        placeholder={placeholder}
        style={{ ...inputStyle, width: "100%" }}
      />
    </div>
  );

  return (
    <SimpleModal
      title={isEdit ? `Edit — ${existingUnit.name}` : "Add Tenant"}
      onClose={onClose}
      onSave={save}
      saving={saving}
      error={error}
      wide
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
        <div>
          {field("Name", "name", "text", "e.g. Smith & Co (optional)")}
        </div>
        <div>
          {field("Number", "unit_number", "text", "e.g. 101 (optional)")}
        </div>
      </div>
      {field("Floor / Level", "floor_level", "text", "e.g. Ground Floor, Level 2")}
      <div style={{ marginBottom: "14px" }}>
        <label style={{ ...labelStyle, display: "block", marginBottom: "4px" }}>Notes</label>
        <textarea
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
          placeholder="Any notes about this unit..."
          style={{ ...inputStyle, width: "100%", height: "72px", resize: "vertical" }}
        />
      </div>
    </SimpleModal>
  );
}
